import React from "react"
import { getAccountSettings } from "../../scripts/accountSettings"
import Color from "color"

import config from "./config"

let stylesLoaded = null

const getStyleForCustomType = (typeName, authenticAccountId) => {
  let result = {}

  const colors = getAccountSettings(authenticAccountId).settings.colours

  for (const t of config[typeName]) {
    result = {
      ...result,
      ...t(typeName, colors)
    }
  }

  return result
}

const setUpStyles = authenticAccountId => {
  const result = {
    default: getStyleForCustomType("default", authenticAccountId),
    type1: getStyleForCustomType("type1", authenticAccountId)
  }

  stylesLoaded = result

  return result
}

const getContentType = authenticAccountId =>
  getAccountSettings(authenticAccountId).settings.style.content || "default"

export const getStyles = (classNames, contentType, authenticAccountId) => {
  if (!contentType) contentType = getContentType(authenticAccountId)

  const styles = stylesLoaded || setUpStyles(authenticAccountId)

  let result = {}

  if (Array.isArray(classNames)) {
    for (const name of classNames) {
      result = {
        ...result,
        ...styles[contentType][name],
        customCSS: undefined
      }
    }
  } else {
    result = {
      ...styles[contentType][classNames],
      customCSS: undefined
    }
  }

  return result
}

export const getStyleTag = (
  classNames,
  contentType,
  skipStyleTag,
  authenticAccountId
) => {
  if (!contentType) contentType = getContentType(authenticAccountId)

  const styles = stylesLoaded || setUpStyles(authenticAccountId)

  let result = ""

  if (Array.isArray(classNames)) {
    for (const name of classNames) {
      const hasCustomCSS =
        styles[contentType][name] && styles[contentType][name].customCSS
      result += hasCustomCSS ? styles[contentType][name].customCSS : ""
    }
  } else {
    const hasCustomCSS =
      styles[contentType][classNames] &&
      styles[contentType][classNames].customCSS
    result = hasCustomCSS ? styles[contentType][classNames].customCSS : ""
  }

  if (skipStyleTag) {
    return result
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: result.replace(/\s\s+/g, " ")
      }}
    />
  )
}

export const hexToRgbA = (hex, opacity) => {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("")
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = "0x" + c.join("")
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      opacity +
      ")"
    )
  } else return hex
}

export const getDarkenColor = (color, darkenValue) =>
  Color(color)
    .darken(darkenValue)
    .hex()
export const getLightenColor = (color, lightenValue) =>
  Color(color)
    .lighten(lightenValue)
    .hex()



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/index.js